<template>
  <div class="holiday-calendar">
    <div class="calendar-legend">
      <span class="legend-item"><i class="legend-dot holiday"></i> 法定节假日</span>
      <span class="legend-item"><i class="legend-dot shift"></i> 调休</span>
    </div>
    <el-calendar v-model="currentDate">
      <template slot="dateCell" slot-scope="{ date, data }">
        <div class="calendar-cell">
          <span class="cell-day">{{ data.day.slice(-2).replace(/^0/, '') }}</span>
          <div v-if="getHoliday(data.day)" class="cell-tag holiday">
            {{ getHoliday(data.day).name || '法定节假日' }}
          </div>
          <div v-else-if="isShiftDay(data.day)" class="cell-tag shift">班</div>
        </div>
      </template>
    </el-calendar>
  </div>
</template>

<script>
export default {
  name: "HolidayCalendar",
  data() {
    return {
      currentDate: new Date(),
      holidays: [],
      shiftDays: [],
    };
  },
  created() {
    const { holidays, shiftDays } = this.getDefaultHolidayData();
    this.holidays = holidays;
    this.shiftDays = shiftDays;
  },
  methods: {
    getDefaultHolidayData() {
      return {
        holidays: [
          { date: "2025-01-01", name: "元旦" },
          { date: "2025-01-28", name: "春节" },
          { date: "2025-01-29", name: "春节" },
          { date: "2025-01-30", name: "春节" },
          { date: "2025-01-31", name: "春节" },
          { date: "2025-02-01", name: "春节" },
          { date: "2025-02-02", name: "春节" },
          { date: "2025-02-03", name: "春节" },
          { date: "2025-02-04", name: "春节" },
          { date: "2025-04-04", name: "清明" },
          { date: "2025-05-01", name: "劳动节" },
          { date: "2025-05-02", name: "劳动节" },
          { date: "2025-05-03", name: "劳动节" },
          { date: "2025-05-04", name: "劳动节" },
          { date: "2025-05-05", name: "劳动节" },
          { date: "2025-05-31", name: "端午" },
          { date: "2025-10-01", name: "国庆" },
          { date: "2025-10-02", name: "国庆" },
          { date: "2025-10-03", name: "国庆" },
          { date: "2025-10-04", name: "国庆" },
          { date: "2025-10-05", name: "国庆" },
          { date: "2025-10-06", name: "中秋" },
          { date: "2025-10-07", name: "国庆" },
          { date: "2026-01-01", name: "元旦" },
          { date: "2026-01-02", name: "元旦" },
          { date: "2026-01-03", name: "元旦" },
          { date: "2026-02-15", name: "春节" },
          { date: "2026-02-16", name: "春节" },
          { date: "2026-02-17", name: "春节" },
          { date: "2026-02-18", name: "春节" },
          { date: "2026-02-19", name: "春节" },
          { date: "2026-02-20", name: "春节" },
          { date: "2026-02-21", name: "春节" },
          { date: "2026-02-22", name: "春节" },
          { date: "2026-02-23", name: "春节" },
          { date: "2026-04-04", name: "清明" },
          { date: "2026-04-05", name: "清明" },
          { date: "2026-04-06", name: "清明" },
          { date: "2026-05-01", name: "劳动节" },
          { date: "2026-05-02", name: "劳动节" },
          { date: "2026-05-03", name: "劳动节" },
          { date: "2026-05-04", name: "劳动节" },
          { date: "2026-05-05", name: "劳动节" },
          { date: "2026-06-19", name: "端午" },
          { date: "2026-06-20", name: "端午" },
          { date: "2026-06-21", name: "端午" },
          { date: "2026-09-25", name: "中秋" },
          { date: "2026-09-26", name: "中秋" },
          { date: "2026-09-27", name: "中秋" },
          { date: "2026-10-01", name: "国庆" },
          { date: "2026-10-02", name: "国庆" },
          { date: "2026-10-03", name: "国庆" },
          { date: "2026-10-04", name: "国庆" },
          { date: "2026-10-05", name: "国庆" },
          { date: "2026-10-06", name: "国庆" },
          { date: "2026-10-07", name: "国庆" },
        ],
        shiftDays: [
          "2025-01-26",
          "2025-02-08",
          "2025-04-27",
          "2025-09-28",
          "2025-10-11",
          "2026-01-04",
          "2026-02-14",
          "2026-02-28",
          "2026-05-09",
          "2026-09-20",
          "2026-10-10",
        ],
      };
    },
    getHoliday(dayStr) {
      const norm = (d) => (typeof d === "string" ? d : d && d.date) ? String(d.date || d).slice(0, 10) : "";
      return (this.holidays || []).find((h) => norm(h) === dayStr);
    },
    isShiftDay(dayStr) {
      return (this.shiftDays || []).some(
        (d) => (typeof d === "string" && d.slice(0, 10) === dayStr) || d === dayStr
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.holiday-calendar {
  .calendar-legend {
    margin-bottom: 12px;
    font-size: 13px;
    color: #606266;
    .legend-item {
      margin-right: 20px;
    }
    .legend-dot {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 2px;
      margin-right: 6px;
      vertical-align: middle;
    }
    .legend-dot.holiday {
      background: #fef0f0;
      border: 1px solid #fde2e2;
    }
    .legend-dot.shift {
      background: #f4f4f5;
      border: 1px solid #e9e9eb;
    }
  }
  ::v-deep .el-calendar-table td {
    padding: 2px;
    vertical-align: top;
  }
  ::v-deep .el-calendar-day {
    padding: 4px;
    height: 80px;
    min-height: 80px;
  }
}

.calendar-cell {
  position: relative;
  height: 100%;
  .cell-day {
    display: block;
    font-size: 14px;
    color: #303133;
    margin-bottom: 4px;
  }
  .cell-tag {
    font-size: 11px;
    padding: 1px 6px;
    border-radius: 2px;
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .cell-tag.holiday {
    background: #fef0f0;
    color: #f56c6c;
    border: 1px solid #fde2e2;
  }
  .cell-tag.shift {
    background: #f4f4f5;
    color: #909399;
    border: 1px solid #e9e9eb;
  }
}
</style>
